
import { defineComponent } from 'vue';

/**
 * Icone de seta.
 * @displayName IconChevron [Componente do UseIcon]
 */
export default defineComponent({
    name: 'IconChevron',
    props: {
        size: {
            type: [String, Number],
            default: 22,
        },
        color: {
            type: String,
            default: 'white',
        },
    },
});
